import { v4 as uuid } from 'uuid'
import Persist from '@services/persist'
import { getConfig } from '@services/context'

export const getUserHash = (): string => {
  const forceUserHash = getConfig('forceUserHash')
  if (forceUserHash) {
    return forceUserHash
  }

  const persistUserHash = Persist.cookie.get<string | null>('userHash')

  if (persistUserHash) {
    return persistUserHash
  } else {
    return rewriteUserHash()
  }
}

export const rewriteUserHash = (): string => {
  const userHash = uuid()

  Persist.cookie.set<string>('userHash', userHash)

  return userHash
}

export const deleteUserHash = (): void => {
  Persist.cookie.remove('userHash')
}
